export default __webpack_public_path__ + "static/media/Dashboard_hero.ad2a6dc4.jpg";